var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-dialogContainer"},[_c('form',{attrs:{"id":_vm.formId}},[_c('div',{staticClass:"h-subscriber-inputLit"},[_vm._v(_vm._s(_vm.$t('MCS.groupNum'))+":")]),_c('ejs-textbox',{attrs:{"value":_vm.numVal,"name":"groupNum"},model:{value:(_vm.numVal),callback:function ($$v) {_vm.numVal=$$v},expression:"numVal"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }